import React from "react";
import PageHeader from "../Pageheader";
import ReUse from "../../services/helpers/reUse";
import Header from "../Header";
import Footer from "../Footer";
import { about1 } from "../../Constant/Index";

const StaticPageContent = ({ data }) => {
  const { type, value, meta_title, meta_keyword, meta_description,top_section_heading } =
    data ?? {};

  return (
    <>
	<Header/>
      <PageHeader pagename={type} />
      {/* Terms And Condition Section */}
      <section className="terms-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="terms-condition-all-para">
                <h1>{meta_title}</h1>
                {ReUse.dangerouslySetInnerHTML({ content: value })}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ========================== */}

			{/* ====================== */}

			{/* Best Product Section */}
			
			{/* ====================================== */}

			{/* Help Customer Section */}
	
			{/* ======================================== */}
			<Footer />
    </>
  );
};

export default StaticPageContent;
